import React from 'react'
import { DatePickerSeeker, disabledBeforeToday } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userPayload } from "Pages/Admin/Users/@signals"
import { parseBackendDate } from "@utils"

export default function UserExpirationDateField() {

	const {
		expirationDate,
		setExpirationDateInfo
	} = useAdminUsersInfo(parseBackendDate(userPayload.peek()?.user?.expirationDate), "expirationDate", "user")
	return <DatePickerSeeker
		cleanable
		value={expirationDate}
		label="Expiration date"
		onChange={e => setExpirationDateInfo(e)}
		shouldDisableDate={disabledBeforeToday()}
		inputProps={{ sx: { backgroundColor: "background.grey" } }}
	/>
}